var VehicleOnTypesReport = (function () {
  var tableId,
    buttonId,
    reportStatus;

  var init = function () {
      $('.select2').select2();

      $.each($('.select2-selection__choice'), function (index, control) {
        var option = Select2Helper().findOption($(control));
        var color = option.data("color");
        if (color) {
          $(control).addClass(color);
        }
      });

      $('.select2-selection__choice').on('click', function () {
        var option = Select2Helper().findOption($(this));
        var href = option.data("href");
        if (href) {
          location.href = href;
        }
      });

      ChosenSelect.Init();
      datetimepickerRangeInit({ $inputFrom: $('#From'), $inputTo: $('#To'), withSeconds: true });

    if ($('#ReportStatus').val() == ReportStatuses.getName(ReportStatuses.InProcess)) {
      $('#' + tableId + '_processing').attr('style', 'display: block;');
      $('#' + buttonId).attr('disabled', 'disabled');
      $('[js=exportToExcel]').attr('disabled', 'disabled');
      $('[js=clearFilter]').attr('disabled', 'disabled');
      $('[js=interruptReport]').show();
    }
  }

  var treesInit = function () {
    $('#byTypesTree').jstree({
      "core": {
        "themes": {
          "icons": false
        }
      }
    });
    $('#byContractorsTree').jstree({
      "core": {
        "themes": {
          "icons": false
        }
      }
    });


    $('#byContractorsTree').on('ready.jstree', function () {
      $('#byContractorsTree').off("click.jstree", ".jstree-anchor");
    });
    $('#byTypesTree').on('ready.jstree', function () {
      $('#byTypesTree').off("click.jstree", ".jstree-anchor");
    });

  }

  var change = function () {
    $('#' + tableId + '_processing').attr('style', 'display: block;');
    $('#' + buttonId).attr('disabled', 'disabled');
    $('[js=interruptReport]').hide();
    $('[js=exportToExcel]').attr('disabled', 'disabled');
    $('[js=clearFilter]').attr('disabled', 'disabled');
    var filter = {
      From: $('#From').val(),
      To: $('#To').val(),
      SelectedContractorIds: $('#SelectedContractorIds').val(),
      SelectedRoadIds: $('#SelectedRoadIds').val(),
      SelectedVehicleTypeIds: $('#SelectedVehicleTypeIds').val(),
      SelectedMinOnObjectValue: $('#SelectedMinOnObjectValue').val()
    };

    $.ajax({
      url: Url.action('vehiclesByTypes/startReport'),
      type: 'POST',
      data: filter
    })
    .success(function (result) {
      if (result.model) {
        if (result.model.ReportStatus == 1) {
          $('#ReportStatus').val(result.model.ReportStatus);
          $('#' + tableId + '_processing').attr('style', 'display: block;');
            $('#' + buttonId).attr('disabled', 'disabled');
          $('[js=clearFilter]').attr('disabled', 'disabled');
          $('[js=exportToExcel]').attr('disabled', 'disabled');
          $('[js=interruptReport]').removeAttr('disabled');
          $('[js=interruptReport]').show();

        }
      }
      if (result.reportId) {
        window.globalReportsId.VehicleOnType = result.reportId;
        localStorage.setItem('globalReportsId', JSON.stringify(window.globalReportsId));
      }
    }).error(function (xhr, status) {
      $('[js=exportToExcel]').removeAttr('disabled');
      $('[js=clearFilter]').removeAttr('disabled');
      $('#' + buttonId).removeAttr('disabled');
      $('#' + tableId + '_processing').attr('style', 'display: none;');
      init();
      console.log(status);
    });
  }

  var initPage = function (option) {
    buttonId = 'applyFilter';
    tableId = 'VehicleOnTypeReportTable';
    reportStatus = option.reportStatus;

    $(document).ready(function() {
      treesInit();
      init();
    });
  }

  var _reInitFunc = () => {
    treesInit();
    init();
  }

    var interrupt = function() {
        var reportId = '';
        if (localStorage.getItem('globalReportsId')) {
            var globalReportId = JSON.parse(localStorage.getItem('globalReportsId'));
            reportId = globalReportId.VehicleOnType;
        }
        $.ajax({
                url: Url.action('api/vehiclesByTypes/report/interrupt'),
                type: 'POST',
                data: {
                    reportId: reportId
                }
            })
            .complete(function() {
                $('[js=interruptReport]').attr('disabled', 'disabled');
            });
    };

    var clearFilter = function () {

        var date = new Date;
        date.setDate(date.getDate() - 1);
        $('#From').data("DateTimePicker").date(date);
        $('#To').data("DateTimePicker").date(new Date);

        $('#SelectedMinOnObjectValue').val('0');

        $('#SelectedVehicleTypeIds').val(null);
        $('#SelectedVehicleTypeIds').trigger('chosen:updated');

        $('#SelectedRoadIds').val(null);
        $('#SelectedRoadIds').trigger('chosen:updated');

        $('#SelectedVehicleIds').val(null);
        $('#SelectedVehicleIds').trigger('chosen:updated');

        $('#SelectedContractorIds').val(null);
        $('#SelectedContractorIds').trigger('chosen:updated');
    };

  return {
    Init: initPage,
    Change: change,
    ClearFilter: clearFilter,
    ReInitFunc: _reInitFunc,
    Interrupt: interrupt
  };
}());
